module.exports = "<div class=\"feed_block\">\n  <iframe class=\"site\" src=\"../../assets/includes/facebook.html\" frameborder=\"0\" scrolling=\"no\"></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/feed-block/feed-block.component.html
// module id = ../../../../../src/app/feed-block/feed-block.component.html
// module chunks = main